// extracted by mini-css-extract-plugin
export default {"baseButton":"buttons_baseButton__Vt1Ow","clrButton":"buttons_clrButton__eOSgL"};